<template>
<div class="error-page" :style="{height:height}">
	<div class="not-logo">
		<img :src="notFound_img"/>
	</div>
	<h1>404 Not Found</h1>
</div>
</template>

<script>
export default{
	name: 'NotFound',
	props: ['height'],
	data() {
		return {
			notFound_img: that.$store.state.Host+'/images/static/img/logo_mobi.png'
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/NotFound.vue